import { useMemo } from "react";
import { useDataAccessContext } from "../Contexts/DataAccessContext";
import { AzureDevOpsConfig } from "../Shared/AzureDevopsConfig";
import { stripAllSpecialChars } from "../Shared/shared.utils";

const { organization, project, repository } = AzureDevOpsConfig;

interface UseGetBranchDetailsProps {
  /**
   * A string to modify the branch name, will appear after the username, should be unique to avoid branch name conflicts.
   * ex: rkambara/branchNameModifier
   */
  branchNameModifier: string;
}

/**
 * Returns the branch name and branch url for the extension details configuration pull request in Azure DevOps based on the current user's username and the extension name.
 */
export const useGetBranchDetails = ({
  branchNameModifier,
}: UseGetBranchDetailsProps) => {
  const { activeAccount } = useDataAccessContext();

  const username = useMemo(() => {
    if (!activeAccount || !activeAccount.username) {
      return "";
    }
    const email = activeAccount.username;
    const alias = email.split("@")[0];
    return alias;
  }, [activeAccount]);

  const branchName = useMemo(() => {
    return `${username}/${stripAllSpecialChars(branchNameModifier)}`;
  }, [username, branchNameModifier]);

  const branchUrl = useMemo(() => {
    return `https://dev.azure.com/${organization}/${project}/_git/${repository}?version=GB${encodeURIComponent(
      branchName,
    )}`;
  }, [branchName]);

  return { branchName, branchUrl };
};
